exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InfiniteScroll-ListWithLoadMore-Button__primary{background-color:#022140;color:#fff}.InfiniteScroll-ListWithLoadMore-Button__primary:focus,.InfiniteScroll-ListWithLoadMore-Button__primary:hover{background-color:rgba(2,33,64,.7)}.InfiniteScroll-ListWithLoadMore-u_spaceTop{margin-top:15px!important;margin-top:.9375rem!important}.InfiniteScroll-ListWithLoadMore-showMoreIcon{clear:both;text-align:center;width:100%;margin:0 auto}", ""]);

// exports
exports.locals = {
	"Button__primary": "InfiniteScroll-ListWithLoadMore-Button__primary",
	"u_spaceTop": "InfiniteScroll-ListWithLoadMore-u_spaceTop",
	"showMoreIcon": "InfiniteScroll-ListWithLoadMore-showMoreIcon"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/InfiniteScroll/ListWithLoadMore.css
// module id = 1002
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20